import React from 'react';
import './Home.css';

export default function Home() {
  return (
    <main className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Welcome to Your Professional Business</h1>
          <p>Delivering excellence and innovation for your business growth.</p>
          <div className="hero-buttons">
            <a href="/contact" className="btn btn-primary">Get Started</a>
            <a href="/portfolio" className="btn btn-secondary">View Portfolio</a>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2>Why Choose Us?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <h3>Expert Team</h3>
              <p>Experienced professionals dedicated to delivering exceptional results.</p>
            </div>
            <div className="feature-card">
              <h3>Proven Track Record</h3>
              <p>Successfully completed 100+ projects with satisfied clients.</p>
            </div>
            <div className="feature-card">
              <h3>24/7 Support</h3>
              <p>Round-the-clock support to ensure your business runs smoothly.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <h2>Ready to Transform Your Business?</h2>
          <p>Let's work together to achieve your goals.</p>
          <a href="/contact" className="btn btn-primary">Contact Us Today</a>
        </div>
      </section>
    </main>
  );
}
